import { FC } from 'react';

import { ReactSwitch } from '@storybook';

interface IAdditionalFlag {
	value: boolean;
	handleChange: (value: boolean) => void;
	heading: string;
	description: string;	
	isDisabled?: boolean;
	isViewOnly?: boolean;
}

export const AdditionalFlag: FC<IAdditionalFlag> = ({
	handleChange,
	value,
	heading,
	description, 
	isDisabled = false,   
	isViewOnly = false,
}) => {
	return (
		<div className='add-recipient__original-copy-wrapper' >
			<div className="add-recipient__original-copy">
				<div className="add-recipient__original-copy__toogle-wrapper">
					<span>{heading}</span>
					{!isViewOnly && <ReactSwitch id={''} checked={value} handleChange={handleChange} isDisabled={isDisabled} />}
				</div>
				<span className="add-recipient__original-copy__toogle-description">
					{description}
				</span>
			</div>
		</div>
	);
};
